import { motion } from 'framer-motion'
import { Card } from '../components/ui/Card'
import { EnvelopeIcon, PhoneIcon, MapPinIcon, ClockIcon } from '@heroicons/react/24/outline'

const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.08 } } }
const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }

const contactInfo = [
  { icon: EnvelopeIcon, label: 'Email', value: 'support@intelcorehub.sbs', href: 'mailto:support@intelcorehub.sbs' },
  { icon: PhoneIcon, label: 'Phone', value: '+1 (555) 123-4567', href: 'tel:+15551234567' },
  { icon: MapPinIcon, label: 'Address', value: '123 Innovation Drive, San Francisco, CA 94105', href: null },
  { icon: ClockIcon, label: 'Hours', value: 'Mon - Fri, 9:00 AM - 6:00 PM PST', href: null },
]

export const ContactUs = () => {
  return (
    <motion.div variants={container} initial="hidden" animate="show" className="space-y-8 max-w-4xl mx-auto">
      <motion.div variants={item} className="text-center">
        <h1 className="text-3xl font-bold text-metallic-900">Contact Us</h1>
        <p className="text-metallic-500 mt-2 max-w-xl mx-auto">
          Have questions about our Enterprise Intelligence platform? We'd love to hear from you. Reach out and our team will get back to you within 24 hours.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {contactInfo.map((c) => (
          <motion.div key={c.label} variants={item}>
            <Card hover className="h-full">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <c.icon className="w-6 h-6 text-primary-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-metallic-500">{c.label}</p>
                  {c.href ? (
                    <a href={c.href} className="text-metallic-900 font-medium hover:text-primary-600 transition-colors">{c.value}</a>
                  ) : (
                    <p className="text-metallic-900 font-medium">{c.value}</p>
                  )}
                </div>
              </div>
            </Card>
          </motion.div>
        ))}
      </div>

      <motion.div variants={item}>
        <Card>
          <h2 className="text-xl font-semibold text-metallic-900 mb-6">Send Us a Message</h2>
          <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-metallic-700 mb-1">Full Name</label>
                <input type="text" placeholder="John Doe" className="w-full px-4 py-2.5 rounded-xl border border-metallic-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm" />
              </div>
              <div>
                <label className="block text-sm font-medium text-metallic-700 mb-1">Email</label>
                <input type="email" placeholder="john@example.com" className="w-full px-4 py-2.5 rounded-xl border border-metallic-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-metallic-700 mb-1">Subject</label>
              <input type="text" placeholder="How can we help?" className="w-full px-4 py-2.5 rounded-xl border border-metallic-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm" />
            </div>
            <div>
              <label className="block text-sm font-medium text-metallic-700 mb-1">Message</label>
              <textarea rows={5} placeholder="Tell us more about your inquiry..." className="w-full px-4 py-2.5 rounded-xl border border-metallic-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm resize-none" />
            </div>
            <button type="submit" className="px-6 py-2.5 bg-primary-600 text-white rounded-xl font-medium text-sm hover:bg-primary-700 transition-colors">
              Send Message
            </button>
          </form>
        </Card>
      </motion.div>
    </motion.div>
  )
}
